import { Component, Input } from '@angular/core';
import { SmallStatusEnum } from '@dash/randy/shared/classes/status.service';

@Component({
    selector: 'app-small-status',
    templateUrl: './small-status.component.html',
    styleUrls: ['./small-status.component.scss'],
    standalone: false
})
export class SmallStatusComponent {
  @Input() status: SmallStatusEnum = null;

  public get SmallStatusEnum() {
    return SmallStatusEnum;
  }
}
